import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "body-nob-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_touch = _resolveDirective("touch")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "nob" }, null, -1)
      ]))])), [
        [
          _directive_touch,
          _ctx.close,
          "swipe",
          { bottom: true }
        ]
      ]),
      (_openBlock(), _createElementBlock("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        class: "modal-close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7.69696 6.00015L11.6485 2.04865C12.1177 1.57946 12.1177 0.821079 11.6485 0.351891C11.1793 -0.117297 10.4209 -0.117297 9.95171 0.351891L6.00019 4.30339L2.04866 0.351891C1.57947 -0.117297 0.821085 -0.117297 0.351893 0.351891C-0.117298 0.821079 -0.117298 1.57946 0.351893 2.04865L4.30342 6.00015L0.351893 9.95165C-0.117298 10.4208 -0.117298 11.1792 0.351893 11.6484C0.585889 11.8824 0.893083 12 1.20028 12C1.50747 12 1.81467 11.8824 2.04866 11.6484L6.00019 7.69691L9.95171 11.6484C10.1857 11.8824 10.4929 12 10.8001 12C11.1073 12 11.4145 11.8824 11.6485 11.6484C12.1177 11.1792 12.1177 10.4208 11.6485 9.95165L7.69696 6.00015Z",
          fill: "currentColor"
        }, null, -1)
      ]))])),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])), [
      [_directive_click_outside, _ctx.close]
    ])
  ]))
}